export default __webpack_public_path__ + "static/media/dineIn.874b4b8e.svg";